// 服务端插件集合导出
import Vue from 'vue'
import VueLazyLoad from 'vue-lazyload'
// import LazyImg from '@/assets/images/1x1.png'

export default () => {
  // 图片懒加载插件
  // Vue.use(VueLazyLoad)
  Vue.use(VueLazyLoad, {
    preLoad: 1.3,
    error: '/loading.jpg',
    loading: '/loading.jpg',
    attempt: 1
  })
}
